import { render, staticRenderFns } from "./myuser-avatar.vue?vue&type=template&id=bae1414e&scoped=true"
import script from "./myuser-avatar.vue?vue&type=script&lang=js"
export * from "./myuser-avatar.vue?vue&type=script&lang=js"
import style0 from "./myuser-avatar.vue?vue&type=style&index=0&id=bae1414e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae1414e",
  null
  
)

export default component.exports